"use client";

var __jsx = React.createElement;
import React from "react";
import { useTranslations } from "next-intl";
import APP_CONFIGURATION from "@lib/app.config";
import useCssModules from "@lib/hooks/use-css-modules";
const FooterCopyrightMessage = () => {
  var _cssModules$footers$f;
  const t = useTranslations("Shared.Layout");
  const {
    cssModules
  } = useCssModules();
  const {
    copyRightClassNames,
    allRightsReservedClassNames,
    entityTextClassNames
  } = (_cssModules$footers$f = cssModules === null || cssModules === void 0 ? void 0 : cssModules.footers.footerBancogral) !== null && _cssModules$footers$f !== void 0 ? _cssModules$footers$f : {};
  return __jsx("div", {
    className: "w-full flex flex-col"
  }, __jsx("span", {
    className: "flex flex-col gap-0"
  }, __jsx("p", {
    className: copyRightClassNames
  }, t("COPYRIGHT_MESSAGE_MOBILE", {
    year: new Date().getFullYear(),
    app: APP_CONFIGURATION.config.appName
  }), " "), __jsx("p", {
    className: allRightsReservedClassNames
  }, t("ALL_RIGHTS_RESERVED"))), __jsx("p", {
    className: entityTextClassNames
  }, t("COPYRIGHT_ADDITIONAL_MESSAGE")));
};
export default FooterCopyrightMessage;